import ApiService from "../../utils/fetch";
const userRolesUrl = `${process.env.REACT_APP_BASE_URL}user-access/`;

export const fetchUserAccess = async () => {
    const url = `${userRolesUrl}fetch-user-details`;
    const response = await ApiService.get(url)
    return response.data;
}

export const fetchRegionsAndPlants = async () => {
    const url = `${userRolesUrl}fetchAllPlants`;
    const response = await ApiService.get(url);
    return response.data;
}

export const fetchMrpControllers = async (mrpPlants) => {
    const url = `${userRolesUrl}fetchMrpController`;
    const payload = { mrpPlants };
    const response = await ApiService.post(url, payload);
    return response.data;
}

export const raiseAccessRequest = async (payload) => {
    const url = `${userRolesUrl}raiseCT-access-request`;
    const response = await ApiService.post(url, payload);
    return response.data;
}